<!-- Nav Menu -->

<template>
  <div id="app" style="position:relative;">
    <Menu :config="env"/>
    <transition name="fade" appear> <router-view :key="$route.fullPath" :config="env" :meta_data="wp_meta_page"/></transition>
    <CookieBanner />
    <Footer :config="env"/>
  </div>
</template>

<style>
@media (min-width: 1200px) {
    .container, .container-sm, .container-md, .container-lg, .container-xl {
        /* max-width: 1640px!important; */
        max-width: 1500px!important;
    }
}
/* @import url('https://fonts.googleapis.com/css2?family=Grift:ital,wght@0,100..900;1,100..900&display=swap'); */
@font-face {
	font-family: 'Grift-Regular';
	font-weight: normal;
	font-style: normal;
	src: url('https://wp-mena.ocs-software.com/wp-content/themes/wp-bootstrap-starter/fonts/Grift-Regular.ttf');
}
:root {
  font-family: 'Grift-Regular', sans-serif;
}
a {
  color: #337ab7!important;
  text-decoration: none;
  background-color: transparent;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-active {
  transition-delay: 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#app {
  font-size: 14pt;
  font-family: 'Grift-Regular', sans-serif;
  font-optical-sizing: auto;
  /* font-weight: 300; */
  font-style: normal;
}
li.nav-item::marker {
  color: transparent;
}
@media only screen and (max-width: 510px) {
  div#app {
    overflow: hidden;
  }
}
@media only screen and (max-width: 480px) {
  #app {
    font-size: 10pt;
  }
}
.cookie-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  max-width: 900px;
  margin: 0 auto;
  background: #1f1f1f;
  color: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  animation: cookieSlideUp .35s ease;
}

.cookie-banner p {
  margin: 0;
  line-height: 1.6;
  font-size: 15px;
  flex: 1;
}

.cookie-banner .buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.cookie-banner button {
  border: none;
  border-radius: 8px;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all .2s ease;
}

.cookie-banner button:first-of-type {
  background: transparent;
  border: 1px solid #666;
  color: #fff;
}

.cookie-banner button:first-of-type:hover {
  background: #333;
}

.cookie-banner button:last-of-type {
  background: #00a651;
  color: #fff;
}

.cookie-banner button:last-of-type:hover {
  background: #008d45;
  transform: translateY(-1px);
}

@keyframes cookieSlideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .cookie-banner {
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding: 18px;
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner .buttons {
    width: 100%;
    flex-direction: column;
  }

  .cookie-banner button {
    width: 100%;
  }
}
</style>

<script>
import Menu from "@/components/menu.vue";
import Footer from "@/components/footer.vue";
import CookieBanner from "@/components/CookieBanner.vue";
import axios from 'axios'
export default {
  components: {
    Menu,
    Footer,
    CookieBanner
  },
  data(){
    return{

      env:[],
      wp_meta_page:[]
    }
  },
  mounted() {
    this.env = process.env,
        axios //add API Call
      .get(
        process.env.VUE_APP_WPAPI_URL  + "wp/v2/pages?per_page=30"
      ) // Page number changed on each page based on JSON page id you are calling
      .then((response) => {
          (this.wp_meta_page= response.data);
      });
  }
};
</script>
